module.exports = __webpack_public_path__ + "img/5_7.08878111.png";